import { useEffect, useState } from 'react';

interface TramitsFilter {
  tipusProces: any;
  filial: string[];
  process: { label: string; value: string }[]; // Nuevo campo
}

interface useTramitsFilterResult {
  data: TramitsFilter;
  loading: boolean;
  error: string | null;
}

/**
 * Hook para cargar opciones de filtros desde la API.
 */
export function useTramitsFilter(apiService: {
  GetTramitsTypes: (param: string, value: string) => Promise<any>;
  GetTramesesFilial: (entity : string) => Promise<string[]>;
}, entity : string): useTramitsFilterResult {
  const [data, setData] = useState<TramitsFilter>({
    tipusProces: [],
    filial: [],
    process: []
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function loadFilters() {
      setLoading(true);
      setError(null);
      try {
        const [tipusProces, filial] = await Promise.all([
          apiService.GetTramitsTypes("entityId", entity),
          apiService.GetFilialsFromEntity(entity)
        ]);

        setData({ tipusProces: tipusProces?.tipus ?? [], filial, process: tipusProces?.proces ?? [] });
      } catch (err: any) {
        console.error('Error carregant opcions de filtres:', err);
        setError(err.message || 'Error desconegut al carregar filtres');
      } finally {
        setLoading(false);
      }
    }

    loadFilters();
  }, [apiService, entity]);

  return { data, loading, error };
}
